import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { NgIf } from '@angular/common';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { webRedirectionUrl } from '../../../constants/web-redirection-url';
import { routes } from '../../../constants/routes';
import { UtilityService } from '../../../services/utility.service';
@Component({
  selector: 'app-suggest-idea',
  templateUrl: './suggest-idea.component.html',
  styleUrls: ['./suggest-idea.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class SuggestIdeaComponent implements OnInit {
  getUserProfileSubs: Subscription;
  private destroy$ = new Subject<boolean>();
  constructor(
    private router: Router,
    private authService: AuthService,
    private utilityService: UtilityService,
  ) {}

  ngOnInit(): void {}

  onSuggestIdea() {
    const url = `${webRedirectionUrl.suggestIdea}`;
    if (this.utilityService.isUserLoggedIn()) {
      this.utilityService.saveUrlandRedirect(url);
      return;
    }
    this.authService.saveWebRedirectUrl(url);
    this.router.navigate(['/', routes.account, routes.login]);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
